import axios from "../axios";

export default {
  getLeftList(){  // 获取左侧筛选列表
    return axios.post("api/item/itemFirstLevel")
  },
  getSecList(data){
    return axios.post("api/item/itemSecondLevelByFirstId",data)
  },
  getCouClass(data){  // 课程筛选
    return axios.post("api/course/getCourseSelection",data)
  }

};